import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Config from "conFig.js";
const Capnhattuyenvantai = React.memo(function Capnhattuyenvantai(props) {
  const { tuyenvantaivalue } = props;
  const [ten, setTen] = React.useState("");
  const [ma, setMa] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getloaivantaitheoid = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getloaituyenvantaiid?id=" +
      tuyenvantaivalue +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setTen(data[0].ten);
          if (data[0].ma != null) setMa(data[0].ma);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    getloaivantaitheoid();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Tên tuyến vận tải"
                variant="outlined"
                size="small"
                value={ten}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Mã tuyến vận tải"
                variant="outlined"
                size="small"
                value={ma}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      <CardFooter style={{ marginBottom: 10 }}>
        <Button color="primary" variant="contained" style={{ height: 27 }}>
          Cập nhật
        </Button>
      </CardFooter>
    </div>
  );
});

Capnhattuyenvantai.propTypes = {
  tuyenvantaivalue: PropTypes.number,
};
export default Capnhattuyenvantai;
